import { render, staticRenderFns } from "./ActionsWidget.vue?vue&type=template&id=16128cf6&scoped=true&"
import script from "./ActionsWidget.vue?vue&type=script&lang=js&"
export * from "./ActionsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ActionsWidget.vue?vue&type=style&index=0&id=16128cf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16128cf6",
  null
  
)

export default component.exports